import { REACT_APP_API_URL } from '../config';
import { get } from '../utility/http';
import { getToken } from '../utility/tokenSlice';

export async function fetchContesti() { 
  try {
    const response = await get('/cnc/ctx?projection=EPSG:3857', true, {}, false);
     
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchContestiPorts() { 
  try {
    const response = await get('/cnc/ctx/ports', true, {}, false);
     
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchNavigazione(id: string, rootContainer: string) {
  try {
    const response = await get(
      `/cnc/ctx/${id}/containers/${rootContainer}?full=false`,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchTaskList(rootContainer: string) {
  try {
    const response = await get(
      `/tasks/tasks/externalref/${rootContainer}?projection=EPSG:3857`,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchTaskAssignment(taskId: string) {
  try {
    const response = await get(
      `/tree/masks/resource/${taskId}`,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}  


function validateResponse(response: any) {

  if (!response.ok) {
    return undefined;
  }
  return response;
}



const basePath = REACT_APP_API_URL;
export const processTasks = async (tasks: any) => {
  for (const task of tasks) {
    if (task.iconPath && task.iconPath != null) {
      await
      fetch(`${basePath}${task.iconPath}`,
        { headers: { 'Authorization': `Bearer ${getToken()}` } }
      )
        .then(validateResponse)
        .then(response => response?.blob())
        .then(blob => {
          task.image = blob ? URL.createObjectURL(blob) : undefined;
          task.imageDone = true; 
        });
    }
  }
};